export default {
    title: 'Company-User',
    titleExt: 'Company-User: <small>Admins, Manager: {em}/{mm}, User: {eu}/{mu}</small>',
    pageTitle: 'ADMIN - COMPANY-USER'
}
